import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25.747h6s1.5 0 1.5 1.5v6s0 1.5-1.5 1.5h-6s-1.5 0-1.5-1.5v-6s0-1.5 1.5-1.5m0 13.5h6s1.5 0 1.5 1.5v6s0 1.5-1.5 1.5h-6s-1.5 0-1.5-1.5v-6s0-1.5 1.5-1.5m13.5-13.5h6s1.5 0 1.5 1.5v6s0 1.5-1.5 1.5h-6s-1.5 0-1.5-1.5v-6s0-1.5 1.5-1.5m0 13.5h6s1.5 0 1.5 1.5v6s0 1.5-1.5 1.5h-6s-1.5 0-1.5-1.5v-6s0-1.5 1.5-1.5"
    }, null, -1)
  ]));
}
const programmingModuleFourLayout = { render };
export {
  programmingModuleFourLayout as default,
  render
};
//# sourceMappingURL=programming-module-four-layout.svg.js.map
